<template>
    <rkm-overlay>
        <rkm-layout-body title="Transferência de paciente entre veículos">
            <template v-slot:actions>
                <rkm-button
                    @click="redirectToList"
                    color="danger"
                >
                    Sair
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List ref="List" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/transferencia/List'

export default {
    components: { List },
    methods: {
        redirectToList() {
            this.$router.push({ name: 'dashboard' })
        },
    },
}
</script>